import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';
import {newGuid} from '../question-helper';
import {QuestionType} from '../../constants';
import {Profession} from '../../models/Profession';
import {Industry} from '../../models/Industry';

declare const $: any;
declare const easyAutocomplete: any;

@Component({
    selector: 'app-question-autocomplete',
    templateUrl: './question-autocomplete.component.html',
    styleUrls: ['./question-autocomplete.component.scss'],
    standalone: false
})
export class QuestionAutocompleteComponent implements OnInit, OnChanges {

  @Input() question: Question;
  @Input() readOnly = false;
  @Input() showLabel = true;
  @Input() items: any[];
  @Input() placeHolder = 'Profession';
  @Input() inputType = 'text';
  @Input() value: any;
  @Output() questionAnswer = new EventEmitter<any>();

  uniqueControlId = `textbox-autocomplete-${newGuid()}`;
  uniqueControlName = `textbox-autocomplete-${newGuid()}`;

  QuestionTypes = QuestionType;
  professions: Profession[] = [];
  industries: Industry[] = [];

  constructor(private globalQuestionService: GlobalQuestionService) {
  }

  ngOnInit(): void {
    //this.startSpinner(true);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue) {
      this.question = changes?.question?.currentValue;
      if (this.question) {
        if (this.question?.question_prompt) {
          this.placeHolder = this.question?.question_prompt;
        }
        this.value = this.question?.answer;
        //this.startSpinner(true);
        this.getData();
      }
    }
  }

  getData(): void {
    if (this.question?.cent_aq_question_type_id === QuestionType.profession) {
      this.value = this.question?.answer;
      this.globalQuestionService.getProfessions()
        .subscribe(x => {
          this.professions = x;
          this.initAutoComplete(this.professions, QuestionType.profession);
          this.startSpinner(false);
        });
    } else if (this.question?.cent_aq_question_type_id === QuestionType.industry) {
      this.globalQuestionService.getIndustries()
        .subscribe(x => {
          this.industries = x;
          this.initAutoComplete(this.industries, QuestionType.industry);
          this.startSpinner(false);
        });
    }
  }

  onChange(type: QuestionType): void {
    this.applyAnswerIfValid();
  }

  // easyAutocomplete only called onChange() from onChooseEvent (a suggestion actually
  // clicked) - typing or clearing the box otherwise never touched question.answer, so
  // Continue stayed enabled on a stale prior answer even after the field was emptied.
  // Validating on every keystroke (not just truthiness) also means garbage text can't
  // enable Continue in the first place - only a real, exact list match can.
  onInputChange(event: Event): void {
    this.value = (event.target as HTMLInputElement).value;
    this.applyAnswerIfValid();
  }

  // free text that doesn't match a real list item isn't a valid answer - wipe the box
  // once the user leaves it rather than leaving garbage sitting there unresolved.
  onBlur(): void {
    if (!this.isValidSelection()) {
      this.value = '';
      $(`#${this.uniqueControlId}`).val('');
      this.applyAnswerIfValid();
    }
  }

  private isValidSelection(): boolean {
    const type = this.question?.cent_aq_question_type_id;
    const list = type === QuestionType.profession ? this.professions : this.industries;
    const matchField = type === QuestionType.profession ? 'profession_sub' : 'industry';
    return !!this.value && !!list?.some(item => item?.[matchField] === this.value);
  }

  private applyAnswerIfValid(): void {
    if (!this.question) return;
    this.question.answer = this.isValidSelection() ? this.value : '';
    this.questionAnswer.emit(this.question);
  }

  startSpinner(start: boolean): void {
    if (start) {
      //this.globalQuestionService.spinner(true);
    } else {
      this.globalQuestionService.spinner(false);
    }
  }

  initAutoComplete(items: any[], type: QuestionType): void {
    setTimeout(() => {
      $(`#${this.uniqueControlId}`).easyAutocomplete({
        data: items,
        getValue: x => {
          if (type === QuestionType.profession) {
            return x.profession_sub;
          } else if (type === QuestionType.industry) {
            return x.industry;
          }
        },
        list: {
          match: {
            enabled: true
          },
          sort: {
            enabled: true // alphabetical order
          },
          onChooseEvent: () => {
            const selected = $(`#${this.uniqueControlId}`).getSelectedItemData();
            if (type === QuestionType.profession) {
              this.value = selected?.profession_sub;
            } else if (type === QuestionType.industry) {
              this.value = selected?.industry;
            }
            this.onChange(type);
          },
        }
      });
    }, 2000);
  }
}
